import styled from '@emotion/styled';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const ArrowRight = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 24 24" {...rest}>
      <path
        d="M9 18L15 12L9 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default ArrowRight;
